export enum CreatorsTypesEnum {
    API_KEY = 'api Key',
    ADMINISTRATOR = 'administrator',
    CLIENT_API_KEY = 'CLIENT_API_KEY',
}

export enum VerificationStatusEnum {
    UNVERIFIED = 'unverified',
    VERIFIED = 'verified',
}

export enum RoleSemanticNameEnum {
    VISUALIZER = 'visualizer',
    EDITOR = 'editor',
    ADMIN = 'admin',
    CUSTOM = 'custom',
}
